// extracted by mini-css-extract-plugin
export default {"component":"O6nca1","active":"GAhZPw","content":"AdNpO1"};